import React from "react";

import { InfoHint } from "../../../components/InfoHint";
import { NOT_ANNUALIZED_LABEL, NOT_ANNUALIZED_NOTE } from "../utils";

export const NotAnnualizedInfo: React.FC = () => (
  <InfoHint title={NOT_ANNUALIZED_NOTE} label={NOT_ANNUALIZED_LABEL} />
);
